module.exports = __webpack_public_path__ + "static/peoplePC-76456db9a0e041aba703945192e40c3d.webp";